import dynamic from 'next/dynamic'

export const DynamicTradeInCategoriesSkeleton = dynamic(() =>
	import('./TradeInCategoriesSkeleton').then(({ TradeInCategoriesSkeleton }) => TradeInCategoriesSkeleton)
)
